import { elevation, themeColors } from "@dana/MobiusOverrides/styles/colors";
import { fontSizes, fontWeights, lineHeights } from "@dana/MobiusOverrides/styles/typography";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Clickable, { ClickablePresentationProps } from "@insite/mobius/Clickable";
import Hidden from "@insite/mobius/Hidden";
import { ModalPresentationProps } from "@insite/mobius/Modal";
import { PageProps } from "@insite/mobius/Page";
import { HasHistory } from "@insite/mobius/utilities/HistoryContext";
import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => {
    const quickOrderUrl = getPageLinkByPageType(state, "QuickOrderPage")?.url;
    return {
        quickOrderUrl,
    };
};

type Props = PageProps & WidgetProps & ReturnType<typeof mapStateToProps> & HasHistory;

export interface QuickOrderButtonStyles {
    quickOrderButton?: ClickablePresentationProps;
    quickOrderModal?: ModalPresentationProps;
}

export const quickOrderButtonStyles: QuickOrderButtonStyles = {
    quickOrderButton: {
        css: css`
            color: ${themeColors.primary.white};
            font-size: ${fontSizes.small};
            line-height: ${lineHeights.small};
            font-weight: ${fontWeights.medium};

            &:hover,
            &:focus,
            &:focus-visible {
                text-decoration: none;
                color: ${themeColors.secondary.danaBrightBlue};
            }

            &:focus,
            &:focus-visible {
                outline: none;
                border: 1px solid ${themeColors.primary.white};
                box-shadow: ${elevation.focus};
            }
        `,
    },
};

const styles = quickOrderButtonStyles;

const QuickOrderButton: React.FC<Props> = ({ quickOrderUrl }) => {
    return (
        <Hidden below="md">
            <Clickable href={quickOrderUrl} {...styles.quickOrderButton} data-test-selector="common_quickOrderButton">
                {translate("Quick Order")}
            </Clickable>
        </Hidden>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(QuickOrderButton),
    definition: {
        group: "Common",
        displayName: "Quick Order Link",
    },
};

export default widgetModule;
